import React from 'react'
import './LoadingNotice.css'

interface LoadingNoticeProps {
  title?: string
  subtitle?: string
}

const LoadingNotice: React.FC<LoadingNoticeProps> = ({
  title = 'Loading data...',
  subtitle = 'Please wait while we fetch the data'
}) => {
  return (
    <div className="loading-notice">
      <div className="spinner"></div>

      <div className="title">{title}</div>

      {subtitle && <div className="subtitle">{subtitle}</div>}

      <style>{`
        .loading-notice {
          position: fixed;
          inset: 0;
          background: rgba(240, 246, 250, 0.95);
          backdrop-filter: blur(8px);
          -webkit-backdrop-filter: blur(8px);
          z-index: 999;

          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          text-align: center;

          padding: 1.5rem;
        }

        @media (min-width: 1024px) {
          .loading-notice {
            top: 90px;
            left: 280px;
          }
        }

        .spinner {
          border: 4px solid #f3f3f3;
          border-top: 4px solid #004b8d;
          border-radius: 50%;
          width: 50px;
          height: 50px;
          animation: loadingNoticeSpin 1s linear infinite;
          margin-bottom: 1rem;
        }

        .title {
          font-size: clamp(16px, 2vw, 18px);
          font-weight: 600;
          color: #333;
          font-family: 'Segoe UI', sans-serif;
          margin-bottom: 0.5rem;
        }

        .subtitle {
          font-size: clamp(13px, 2vw, 14px);
          color: #666;
          font-family: 'Segoe UI', sans-serif;
          max-width: 400px;
        }

        @keyframes loadingNoticeSpin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  )
}

export default LoadingNotice